// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminGroupPage {
  padding: 14px 0 28px;
}

.adminGroupHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin: 10px 0 14px;
}

.adminGroupTitle {
  font-size: 22px;
  font-weight: 900;
}

.adminGroupSubtitle {
  color: var(--gris-terciaire);
  margin-top: 4px;
}

.adminGroupActions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.adminBtn {
  border: 0;
  border-radius: 12px;
  padding: 10px 12px;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 8px;
}

.adminBtnSoft {
  background: #f3f4f6;
  color: #111827;
}

.adminBtnPrimary {
  background: var(--couleur-principale);
  color: #fff;
}

.adminGroupFilters {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 12px;
  margin: 10px 0 14px;
}

.filterItem label {
  font-size: 12px;
  font-weight: 900;
  color: var(--gris-terciaire);
  margin-bottom: 6px;
}

.adminGroupTableWrap {
  background: #fff;
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(17, 24, 39, .06);
}

.adminGroupTable thead th {
  font-size: 12px;
  color: var(--gris-terciaire);
  font-weight: 900;
  border-bottom: 1px solid #e5e7eb;
}

.rowTitle {
  font-weight: 900;
}

.rowMuted {
  font-size: 12px;
  color: var(--gris-terciaire);
}

.rowActions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btnAction {
  border: 0;
  border-radius: 10px;
  padding: 8px 10px;
  background: #f3f4f6;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btnDanger {
  background: #fee2e2;
  color: #991b1b;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
}

.pillGood {
  background: #dcfce7;
  color: #166534;
}

.pillDanger {
  background: #ffe4e6;
  color: #9f1239;
}

.pillNeutral {
  background: #f3f4f6;
  color: #111827;
}

.adminEmpty {
  padding: 18px;
  text-align: center;
  color: var(--gris-terciaire);
  font-weight: 800;
}

.adminPagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.pageInfo {
  color: var(--gris-terciaire);
  font-weight: 800;
}

/* Modal */
.adminModalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 9999;
  animation: overlayFadeIn 0.18s ease-out;
}

.adminModal {
  width: min(720px, 100%);
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, .2);
  overflow: hidden;
  /* overflow: hidden ici n'a plus d'impact sur le dropdown puisqu'il sort du DOM du modal via le portal */
}

.adminModalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.adminModalTitle {
  font-weight: 900;
  font-size: 16px;
}

.adminModalClose {
  border: 0;
  background: transparent;
  font-size: 18px;
}

.adminModalBody {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.adminModalFooter {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 16px;
  border-top: 1px solid #e5e7eb;
}

@media (max-width: 992px) {
  .adminGroupFilters {
    grid-template-columns: 1fr;
  }
}

.adminGroupTableWrap {
  background: #fff;
  border-radius: 16px;
  padding: 4px;
  box-shadow: 0 10px 30px rgba(17, 24, 39, .06);
}

.tableScroll {
  overflow-x: auto;
}

.adminGroupTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
}

.adminGroupTable thead th {
  position: sticky;
  top: 0;
  background: #fff;
  font-size: 12px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
  z-index: 1;
}

.adminGroupTable thead th.colActions {
  text-align: right;
}

.adminGroupTable tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f2f4;
  vertical-align: middle;
}

.adminGroupTable tbody tr:last-child td {
  border-bottom: none;
}

.adminGroupTable tbody tr {
  transition: background-color .15s ease;
}

.adminGroupTable tbody tr:hover {
  background-color: #fafafa;
}

.rowTitle {
  font-weight: 900;
  color: #111827;
}

.validityDates {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  white-space: nowrap;
}

.validityDates i {
  color: var(--gris-terciaire);
  font-size: 11px;
}

/* ===== PILLS ===== */
.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.pillGood {
  background: #dcfce7;
  color: #166534;
}

.pillDanger {
  background: #ffe4e6;
  color: #9f1239;
}

.pillNeutral {
  background: #f3f4f6;
  color: #111827;
}

.pillArchived {
  background: #fef3c7;
  color: #92400e;
}

.pillPercent {
  display: inline-block;
  background: #eef2ff;
  color: #3730a3;
}

/* ===== ACTIONS ===== */
.rowActions {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.btnAction {
  border: 0;
  border-radius: 10px;
  width: 34px;
  height: 34px;
  background: #f3f4f6;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .15s ease, color .15s ease, transform .1s ease;
}

.btnAction:hover {
  transform: translateY(-1px);
}

.btnAction--edit:hover {
  background: #dbeafe;
  color: #1d4ed8;
}

.btnAction--toggle:hover {
  background: #dcfce7;
  color: #166534;
}

.btnAction--archive:hover {
  background: #fef3c7;
  color: #92400e;
}

.btnAction--delete:hover {
  background: #fee2e2;
  color: #991b1b;
}

/* ===== EMPTY STATE ===== */
.adminEmpty {
  padding: 48px 18px;
  text-align: center;
  color: var(--gris-terciaire);
  font-weight: 800;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.adminEmpty i {
  font-size: 28px;
  opacity: .5;
}

@media (max-width: 768px) {
  .adminGroupTable thead th,
  .adminGroupTable tbody td {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionCoupon/AdminCouponPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,wGAAwG;AAC1G;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;;IAEE,aAAa;EACf;AACF","sourcesContent":[".adminGroupPage {\n  padding: 14px 0 28px;\n}\n\n.adminGroupHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  margin: 10px 0 14px;\n}\n\n.adminGroupTitle {\n  font-size: 22px;\n  font-weight: 900;\n}\n\n.adminGroupSubtitle {\n  color: var(--gris-terciaire);\n  margin-top: 4px;\n}\n\n.adminGroupActions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminBtn {\n  border: 0;\n  border-radius: 12px;\n  padding: 10px 12px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.adminBtnSoft {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.adminBtnPrimary {\n  background: var(--couleur-principale);\n  color: #fff;\n}\n\n.adminGroupFilters {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 12px;\n  margin: 10px 0 14px;\n}\n\n.filterItem label {\n  font-size: 12px;\n  font-weight: 900;\n  color: var(--gris-terciaire);\n  margin-bottom: 6px;\n}\n\n.adminGroupTableWrap {\n  background: #fff;\n  border-radius: 16px;\n  padding: 10px;\n  box-shadow: 0 10px 30px rgba(17, 24, 39, .06);\n}\n\n.adminGroupTable thead th {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.rowTitle {\n  font-weight: 900;\n}\n\n.rowMuted {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n.rowActions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.btnAction {\n  border: 0;\n  border-radius: 10px;\n  padding: 8px 10px;\n  background: #f3f4f6;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btnDanger {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.pillGood {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.pillDanger {\n  background: #ffe4e6;\n  color: #9f1239;\n}\n\n.pillNeutral {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.adminEmpty {\n  padding: 18px;\n  text-align: center;\n  color: var(--gris-terciaire);\n  font-weight: 800;\n}\n\n.adminPagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.pageInfo {\n  color: var(--gris-terciaire);\n  font-weight: 800;\n}\n\n/* Modal */\n.adminModalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(3px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 9999;\n  animation: overlayFadeIn 0.18s ease-out;\n}\n\n.adminModal {\n  width: min(720px, 100%);\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, .2);\n  overflow: hidden;\n  /* overflow: hidden ici n'a plus d'impact sur le dropdown puisqu'il sort du DOM du modal via le portal */\n}\n\n.adminModalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.adminModalTitle {\n  font-weight: 900;\n  font-size: 16px;\n}\n\n.adminModalClose {\n  border: 0;\n  background: transparent;\n  font-size: 18px;\n}\n\n.adminModalBody {\n  padding: 16px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.adminModalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n@media (max-width: 992px) {\n  .adminGroupFilters {\n    grid-template-columns: 1fr;\n  }\n}\n\n.adminGroupTableWrap {\n  background: #fff;\n  border-radius: 16px;\n  padding: 4px;\n  box-shadow: 0 10px 30px rgba(17, 24, 39, .06);\n}\n\n.tableScroll {\n  overflow-x: auto;\n}\n\n.adminGroupTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin: 0;\n}\n\n.adminGroupTable thead th {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.adminGroupTable thead th.colActions {\n  text-align: right;\n}\n\n.adminGroupTable tbody td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f2f4;\n  vertical-align: middle;\n}\n\n.adminGroupTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.adminGroupTable tbody tr {\n  transition: background-color .15s ease;\n}\n\n.adminGroupTable tbody tr:hover {\n  background-color: #fafafa;\n}\n\n.rowTitle {\n  font-weight: 900;\n  color: #111827;\n}\n\n.validityDates {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.validityDates i {\n  color: var(--gris-terciaire);\n  font-size: 11px;\n}\n\n/* ===== PILLS ===== */\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 900;\n  white-space: nowrap;\n}\n\n.pillGood {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.pillDanger {\n  background: #ffe4e6;\n  color: #9f1239;\n}\n\n.pillNeutral {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.pillArchived {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.pillPercent {\n  display: inline-block;\n  background: #eef2ff;\n  color: #3730a3;\n}\n\n/* ===== ACTIONS ===== */\n.rowActions {\n  display: flex;\n  gap: 6px;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n}\n\n.btnAction {\n  border: 0;\n  border-radius: 10px;\n  width: 34px;\n  height: 34px;\n  background: #f3f4f6;\n  color: #4b5563;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color .15s ease, color .15s ease, transform .1s ease;\n}\n\n.btnAction:hover {\n  transform: translateY(-1px);\n}\n\n.btnAction--edit:hover {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.btnAction--toggle:hover {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.btnAction--archive:hover {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.btnAction--delete:hover {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* ===== EMPTY STATE ===== */\n.adminEmpty {\n  padding: 48px 18px;\n  text-align: center;\n  color: var(--gris-terciaire);\n  font-weight: 800;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.adminEmpty i {\n  font-size: 28px;\n  opacity: .5;\n}\n\n@media (max-width: 768px) {\n  .adminGroupTable thead th,\n  .adminGroupTable tbody td {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
